//获客赋能_年收入10万保险配置
const income = r =>
    require.ensure([], () => r(require("@/pages/agentShare/income")), "income");
//获客赋能_年收入10万保险配置
const fmlPremiumCalculation = r =>
    require.ensure([], () => r(require("@/pages/agentShare/fmlPremiumCalculation")), "fmlPremiumCalculation");
//获客赋能_健康告知
const healthNotification = r =>
    require.ensure([], () => r(require("@/pages/agentShare/healthNotification")), "healthNotification");
//获客赋能_儿童节主题素材
const childrensDay = r =>
    require.ensure([], () => r(require("@/pages/agentShare/childrensDay")), "childrensDay");
//获客赋能_消费型返还型怎么选
const consumptionReturn = r =>
    require.ensure([], () => r(require("@/pages/agentShare/consumptionReturn")), "consumptionReturn");
//获客赋能_55岁以上父母保险配置
const agedIns = r =>
    require.ensure([], () => r(require("@/pages/agentShare/agedIns")), "agedIns");
//获客赋能_第一次买保险怎么选
const firstBuyIns = r =>
    require.ensure([], () => r(require("@/pages/agentShare/firstBuyIns")), "firstBuyIns");
//获客赋能_重疾险医疗险的区别
const difference = r =>
    require.ensure([], () => r(require("@/pages/agentShare/difference")), "difference");
//获客赋能_一家三口保险配置
const threeFml = r =>
    require.ensure([], () => r(require("@/pages/agentShare/threeFml")), "threeFml");
//获客赋能_人生不同阶段保险配置
const differentStages = r =>
    require.ensure([], () => r(require("@/pages/agentShare/differentStages")), "differentStages");
//获客赋能_健康医疗全新升级
const healthcare = r =>
    require.ensure([], () => r(require("@/pages/agentShare/healthcare")), "healthcare");
//获客赋能_普通工薪阶层保险配置
const salaryEarners = r =>
    require.ensure([], () => r(require("@/pages/agentShare/salaryEarners")), "salaryEarners");
//获客赋能_小额医疗险配置
const micromedicine = r =>
    require.ensure([], () => r(require("@/pages/agentShare/micromedicine")), "micromedicine");
//获客赋能_1000元配齐孩子保险
const childIns = r =>
    require.ensure([], () => r(require("@/pages/agentShare/childIns")), "childIns");
//获客赋能_买保险要不要体检
const physicalExamination = r =>
    require.ensure([], () => r(require("@/pages/agentShare/physicalExamination")), "physicalExamination");
//获客赋能_个人保费测算
const personalIns = r =>
    require.ensure([], () => r(require("@/pages/agentShare/personalIns")), "personalIns");
//获客赋能_手足口
const hfmd = r =>
    require.ensure([], () => r(require("@/pages/agentShare/hfmd")), "hfmd");
//获客赋能_生日前后体检
const birthdayPE = r =>
    require.ensure([], () => r(require("@/pages/agentShare/birthdayPE")), "birthdayPE");
//获客赋能_父亲节主题素材
const fathersDay = r =>
    require.ensure([], () => r(require("@/pages/agentShare/fathersDay")), "fathersDay");
//获客赋能_父母意外险
const parentalAccidentIns = r =>
    require.ensure([], () => r(require("@/pages/agentShare/parentalAccidentIns")), "parentalAccidentIns");
//获客赋能_端午节出行
const dragonBoatFestivalTravel = r =>
    require.ensure([], () => r(require("@/pages/agentShare/dragonBoatFestivalTravel")), "dragonBoatFestivalTravel");
//获客赋能_保险避坑
const safeHaven = r =>
    require.ensure([], () => r(require("@/pages/agentShare/safeHaven")), "safeHaven");
//获客赋能_全职妈妈
const fullMother = r =>
    require.ensure([], () => r(require("@/pages/agentShare/fullMother")), "fullMother");
//获客赋能_保险合同理赔
const insClaims = r =>
    require.ensure([], () => r(require("@/pages/agentShare/insClaims")), "insClaims");

//获客赋能_保险小白必看攻略----7个视频
const noExperienceStrategy = r =>
    require.ensure([], () => r(require("@/pages/agentShare/noExperienceStrategy")), "noExperienceStrategy");

//获客赋能_妈咪宝贝全网停售
const mamyHaltSales = r =>
    require.ensure([], () => r(require("@/pages/agentShare/mamyHaltSales")), "mamyHaltSales");

//获客赋能_重疾险怎么选
const chooseIns = r =>
    require.ensure([], () => r(require("@/pages/agentShare/chooseIns")), "chooseIns");

//获客赋能_少儿保险
const childrenPolicy = r =>
    require.ensure([], () => r(require("@/pages/agentShare/childrenPolicy")), "childrenPolicy");

//获客赋能_肥胖人群保险配置
const obesePeopleIns = r =>
    require.ensure([], () => r(require("@/pages/agentShare/obesePeopleIns")), "obesePeopleIns");

//获客赋能_少儿保险页面集合-7个视频
const childrensInsPool = r =>
    require.ensure([], () => r(require("@/pages/agentShare/childrensInsPool")), "childrensInsPool");

//获客赋能_买保险看品牌还是看公司
const brandOrcompany = r =>
    require.ensure([], () => r(require("@/pages/agentShare/brandOrcompany")), "brandOrcompany");

//获客赋能_降低保费预算
const lowerBudget = r =>
    require.ensure([], () => r(require("@/pages/agentShare/lowerBudget")), "lowerBudget");

//获客赋能_5步搞定保险规划
const fiveSteps = r =>
    require.ensure([], () => r(require("@/pages/agentShare/fiveSteps")), "fiveSteps");

//获客赋能_保险顾问无可替代性
const insConsultant = r =>
    require.ensure([], () => r(require("@/pages/agentShare/insConsultant")), "insConsultant");

//获客赋能_保险避坑指南集合
const safeHavenMuster = r =>
    require.ensure([], () => r(require("@/pages/agentShare/safeHavenMuster")), "safeHavenMuster");

//获客赋能_七夕
const seventhMoon = r =>
    require.ensure([], () => r(require("@/pages/agentShare/seventhMoon")), "seventhMoon");

//获客赋能_学平险
const schoolIns = r =>
    require.ensure([], () => r(require("@/pages/agentShare/schoolIns")), "schoolIns");

//获客赋能_单身女性
const singleWomen = r =>
    require.ensure([], () => r(require("@/pages/agentShare/singleWomen")), "singleWomen");

//获客赋能_众惠百万医疗2020
const zhCustomeize = r =>
    require.ensure([], () => r(require("@/pages/agentShare/zhCustomeize")), "zhCustomeize");

//获客赋能_众惠百万医疗2020
const productDiscontinuation = r =>
    require.ensure([], () => r(require("@/pages/agentShare/productDiscontinuation")), "productDiscontinuation");

//获客赋能_理赔相关
const claimsRelated = r =>
    require.ensure([], () => r(require("@/pages/agentShare/claimsRelated")), "claimsRelated");

//获客赋能_教育金
const education = r =>
    require.ensure([], () => r(require("@/pages/agentShare/education")), "education");

//获客赋能_孩子保险公开课H5
const openClass = r =>
    require.ensure([], () => r(require("@/pages/agentShare/openClass")), "openClass");
//获客赋能_孩子保险公开课H52
const openClass2 = r =>
    require.ensure([], () => r(require("@/pages/agentShare/openClass2")), "openClass2");
//获客赋能_孩子保险公开课H52
const openClass3 = r =>
    require.ensure([], () => r(require("@/pages/agentShare/openClass3")), "openClass3");

//获客赋能_国庆意外险
const nationalDay = r =>
    require.ensure([], () => r(require("@/pages/agentShare/nationalDay")), "nationalDay");
//获客赋能_众安意外险
const zaAccident = r =>
    require.ensure([], () => r(require("@/pages/agentShare/zaAccident")), "zaAccident");

//获客赋能_买保险真的就保险了吗
const reallyIns = r =>
    require.ensure([], () => r(require("@/pages/agentShare/reallyIns")), "reallyIns");

let egoRouter2 = [
    {
        path: "/hkfn_income",
        component: income,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险管家"
        }
    },
    {
        path: "/hkfn_fmlPremiumCalculation",
        component: fmlPremiumCalculation,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险管家"
        }
    },
    // 优化到这里
    {
        path: "/hkfn_childrensDay",
        component: childrensDay,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险管家"
        }
    },
    {
        path: "/hkfn_healthNotification",
        component: healthNotification,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险管家"
        }
    },
    {
        path: "/hkfn_consumptionReturn",
        component: consumptionReturn,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险管家"
        }
    },
    {
        path: "/hkfn_agedIns",
        component: agedIns,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险管家"
        }
    },
    {
        path: "/hkfn_firstBuyIns",
        component: firstBuyIns,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险管家"
        }
    },
    {
        path: "/hkfn_difference",
        component: difference,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险管家"
        }
    },
    {
        path: "/hkfn_threeFml",
        component: threeFml,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险管家"
        }
    },
    {
        path: "/hkfn_differentStages",
        component: differentStages,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险管家"
        }
    },
    {
        path: "/hkfn_healthcare",
        component: healthcare,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险管家"
        }
    },
    {
        path: "/hkfn_salaryEarners",
        component: salaryEarners,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险管家"
        }
    },
    {
        path: "/hkfn_micromedicine",
        component: micromedicine,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险管家"
        }
    },
    {
        path: "/hkfn_childIns",
        component: childIns,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险管家"
        }
    },
    {
        path: "/hkfn_physicalExamination",
        component: physicalExamination,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险管家"
        }
    },
    {
        path: "/hkfn_personalIns",
        component: personalIns,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险管家"
        }
    },
    {
        path: "/hkfn_hfmd",
        component: hfmd,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险管家"
        }
    },
    {
        path: "/hkfn_birthdayPE",
        component: birthdayPE,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险管家"
        }
    },
    {
        path: "/hkfn_fathersDay",
        component: fathersDay,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险管家"
        }
    },
    {
        path: "/hkfn_parentalAccidentIns",
        component: parentalAccidentIns,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险管家"
        }
    },
    {
        path: "/hkfn_dragonBoatFestivalTravel",
        component: dragonBoatFestivalTravel,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险管家"
        }
    },
    {
        path: "/hkfn_safeHaven",
        component: safeHaven,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险管家"
        }
    },
    {
        path: "/hkfn_fullMother",
        component: fullMother,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险管家"
        }
    },
    {
        path: "/hkfn_insClaims",
        component: insClaims,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险管家"
        }
    },
    {
        path: "/hkfn_noExperienceStrategy",
        component: noExperienceStrategy,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险管家"
        }
    },
    {
        path: "/hkfn_mamyHaltSales",
        component: mamyHaltSales,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险管家"
        }
    },
    {
        path: "/hkfn_chooseIns",
        component: chooseIns,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险管家"
        }
    },
    {
        path: "/hkfn_childrenPolicy",
        component: childrenPolicy,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险管家"
        }
    },
    {
        path: "/hkfn_obesePeopleIns",
        component: obesePeopleIns,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险管家"
        }
    },
    {
        path: "/hkfn_childrensInsPool",
        component: childrensInsPool,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险管家"
        }
    },
    {
        path: "/hkfn_brandOrcompany",
        component: brandOrcompany,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险管家"
        }
    },
    {
        path: "/hkfn_lowerBudget",
        component: lowerBudget,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险管家"
        }
    },
    {
        path: "/hkfn_fiveSteps",
        component: fiveSteps,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险管家"
        }
    },
    {
        path: "/hkfn_insConsultant",
        component: insConsultant,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险管家"
        }
    },
    {
        path: "/hkfn_safeHavenMuster",
        component: safeHavenMuster,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险管家"
        }
    },
    {
        path: "/hkfn_seventhMoon",
        component: seventhMoon,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险管家"
        }
    },
    {
        path: "/hkfn_schoolIns",
        component: schoolIns,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险管家"
        }
    }, {
        path: "/hkfn_singleWomen",
        component: singleWomen,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险管家"
        }
    },
    {
        path: "/hkfn_zh2020",
        component: zhCustomeize,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险管家"
        }
    },
    {
        path: "/hkfn_productDiscontinuation",
        component: productDiscontinuation,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险管家"
        }
    }
    ,
    {
        path: "/hkfn_claimsRelated",
        component: claimsRelated,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险管家"
        }
    },
    {
        
        path: "/hkfn_education",
        component: education,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险管家"
        }
    },
    {
        
        path: "/hkfn_openClass",
        component: openClass,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险管家"
        }
    },
    {
        
        path: "/hkfn_openClass2",
        component: openClass2,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险管家"
        }
    },
    {
        
        path: "/hkfn_openClass3",
        component: openClass3,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险管家"
        }
    },
    {
        path: "/hkfn_nationalDay",
        component: nationalDay,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险管家"
        }
    },
    {   
        path: "/hkfn_zaAccident",
        component: zaAccident,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险管家"
        }
    },
    {   
        path: "/hkfn_reallyIns",
        component: reallyIns,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险管家"
        }
    }

]
export default egoRouter2



// WEBPACK FOOTER //
// ./src/router/egoRouter2.js